export default __webpack_public_path__ + "static/media/done.7b3ff0b4.svg";